module.exports = require("./../../_gen/openfl/system/Security");